<template>
  <div>
    <div class="header-wrap">
      <hr>
      <div>
        <h2 class="font-weight-bold pb-2">合作品牌</h2>
        <span class="text-muted">COOPERATION&nbsp;&nbsp;&nbsp;BRAND</span>
      </div>
      <hr>
    </div>
    <div class="d-flex flex-wrap mt-5 mb-5 justify-content-between">
      <div class="hexagon d-flex flex-column justify-content-center" :class="{hoverHexagon:showCoopHotelFlag === index}"
           @mouseenter="showCoopHotelFlag = index" @mouseleave="showCoopHotelFlag = null"
           v-for="(item,index) in brandCooperate" :key="index">
        <!--原始显示状态-->
        <div class="d-flex flex-column justify-content-center align-items-center"
             v-if="showCoopHotelFlag !== index">
          <img :src="ImgPreUrl + item.pic" height="49" width="100"/>
          <span class="h6 mb-2 mt-1">—— Coop Hotel ——</span>
          <span class="font-weight-bold h6">{{item.title}}</span>
        </div>
        <!--hover后显示的内容-->
        <div v-if="showCoopHotelFlag === index" class="d-flex flex-column justify-content-center">
          <span class="font-weight-bold h5 text-warning">{{item.title}}</span>
          <hr style="width: 60%; background-color: #fff;margin: 10px auto"/>
          <span class="font-weight-bold h5 text-warning cursor-pointer" v-if="item.custom!=0"
                @click="$router.push('/index_hotel/hotel_detail/'+item.custom)">查看详情</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'CooperateBrand',
    props: {
      brandCooperate: {
        type: Array,
        default: () => {
          return [];
        }
      },
    },
    data() {
      return {
        showCoopHotelFlag: null,
      }
    },
    computed: {
      ...mapState(['userLoginMessage']),
    }
  }
</script>

<style lang="scss" scoped>
  .header-wrap {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin: 80px 0 30px 0;
    hr {
      width: 35%;
      border: 1px solid transparent;
      border-top: 1px solid #ebf0f6;
      -webkit-margin-start: 0;
      -webkit-margin-end: 0;
    }
  }

  .hexagon {
    width: 170px;
    height: 210px;
    background: url("/images/public/hexagon.png") no-repeat center;
    background-size: cover;
    margin-bottom: 28px;
    padding: 0 15px;
  }

  .hoverHexagon {
    background: url("/images/public/hexagonHover.png") no-repeat center;
  }
</style>
